<template>
  <div class="error-404">
    <div class="error-404__container">
      <div class="error-404__container__error">
        4
        <img :src="require('@/assets/img/characters/searchgator.svg')" class="error-404__container__error__img" />
        4
      </div>
      <div class="error-404__container__title">
        {{ $t('errors.404.title') }}
      </div>
      <div class="error-404__container__description">
        {{ $t('errors.404.description') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
}
</script>

<style lang="scss">
.error-404 {
  display: flex;
  background-color: $generic-color-bg;
  min-height: 100vh;

  &__container {
    margin: auto;
    padding: $gutter-sm;

    @media (min-width: $screen-sm) {
      padding: $gutter-md;
    }

    &__error {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      font-size: 6rem;
      font-weight: bold;

      @media (min-width: $screen-sm) {
        font-size: 10rem;
      }

      &__img {
        margin: -10px 10px 0;
        height: 100px;

        @media (min-width: $screen-sm) {
          margin: -20px 20px 0;
          height: 150px;
        }
      }
    }

    &__title {
      margin-top: 24px;
      text-align: center;
      line-height: 1;
      font-size: 2rem;
      font-weight: bold;

      @media (min-width: $screen-sm) {
        font-size: 3rem;
      }
    }

    &__description {
      margin-top: $spacing-md;
      text-align: center;
      font-size: $font-size-default;

      @media (min-width: $screen-sm) {
        font-size: 1rem;
      }
    }
  }
}
</style>
